import { Severity } from '@/state';

/** Must match the event validation in bff/server.mts. */
export interface LogEntry {
    session: string;
    message: string;
    data: object;
    hash: string;
    severity: Severity;
    agent: string;
}

const loggingOrigins = new Set([
    'https://vegkart.utv.atlas.vegvesen.no',
    'https://vegkart.test.atlas.vegvesen.no',
    'https://vegkart.atlas.vegvesen.no',
]);

export function sendLog(event: LogEntry): Promise<void> | undefined {
    if (!loggingOrigins.has(window.location.origin)) return undefined;
    return postLog(event);
}

async function postLog(event: LogEntry): Promise<void> {
    try {
        const response = await fetch('/api/log', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(event),
            credentials: 'omit',
            redirect: 'error',
            signal: AbortSignal.timeout(6000),
        });
        if (!response.ok) {
            console.warn('Vegkart logging failed:', response.status);
        }
    } catch {
        // Logging failures must not trigger Redux error reporting and another log request.
        console.warn('Vegkart logging request failed');
    }
}
